import VisuallyHidden, { VisuallyHiddenProps } from './VisuallyHidden';

export default VisuallyHidden;
export type { VisuallyHiddenProps };
